
import { SocialTask } from '../types';
import { functions } from '../../infrastructure/firebaseConfig';
import { httpsCallable } from "firebase/functions";
import { logger } from '../../infrastructure/logger';

export const socialService = {
    /**
     * Verifies and awards points for a social task via secure Cloud Function.
     */
    async claimTaskReward(userId: string, task: SocialTask): Promise<{ success: boolean; newPoints?: number; message?: string }> {
        try {
            const completeTaskFn = httpsCallable<{ taskId: string, points: number }, { success: boolean, message: string }>(functions, 'completeSocialTask');
            const result = await completeTaskFn({ 
                taskId: task.id, 
                points: task.points 
            });
            
            return { 
                success: result.data.success, 
                message: result.data.message 
            };
        } catch (error) {
            logger.error('[SocialService] Social Claim Error', error);
            return { success: false, message: 'No se pudo validar la recompensa' };
        }
    }
};
